// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Env from "../../core/Env.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as Page from "../../resources/layout-and-structure/Page.res.js";
import * as Group from "../../resources/layout-and-structure/Group.res.js";
import * as Label from "../../primitives/Label.res.js";
import * as Modal from "../../resources/overlays/Modal.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as Title from "../../resources/typography/Title.res.js";
import * as React from "react";
import * as Banner from "../../resources/feedback-indicators/Banner.res.js";
import * as Button from "../../resources/actions/Button.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Request from "../../core/Request.res.js";
import * as TextLink from "../../resources/navigation/TextLink.res.js";
import * as AsyncData from "../../primitives/AsyncData.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as HelpCenter from "../../core/HelpCenter.res.js";
import * as IconButton from "../../resources/actions/IconButton.res.js";
import * as TextAction from "../../resources/actions/TextAction.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as FuturePromise from "rescript-future/src/FuturePromise.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as InputTextField from "../../resources/selection-and-input/InputTextField.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as InputSelectField from "../../resources/selection-and-input/InputSelectField.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as ReactUpdateEffect from "../../primitives/ReactUpdateEffect.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as FieldsetLayoutPanel from "../../resources/layout-and-structure/FieldsetLayoutPanel.res.js";
let printersHubName = "StarPrintersHub";
function errorMessageFromError(error) {
  switch (error) {
    case "InvalidAPIKey":
      return I18n.t("settings_label_printer_page.request_error.invalid_api_key");
    case "NoPrinterFound":
    case "UnexpectedFailure":
      return I18n.t("settings_label_printer_page.request_error.unexpected_failure");
  }
}
function makeEndpoint(shopId) {
  return Env.gatewayUrl() + "/printers-hub/" + printersHubName + "/" + shopId + "/printers";
}
function decodeResultItem(json) {
  let decodeConfig = json => {
    if (json === undefined) {
      return;
    }
    if (typeof json !== "object" || json === null || Array.isArray(json)) {
      return;
    }
    let match = json["id"];
    let match$1 = json["groupId"];
    if (typeof match === "string" && typeof match$1 === "string") {
      return [match, match$1];
    }
  };
  if (typeof json !== "object" || json === null || Array.isArray(json)) {
    return;
  }
  let match = json["name"];
  let match$1 = json["hubName"];
  let match$2 = json["macAddress"];
  let match$3 = decodeConfig(json["config"]);
  if (typeof match === "string" && typeof match$1 === "string" && typeof match$2 === "string" && match$3 !== undefined) {
    return {
      id: match$3[0],
      groupId: match$3[1],
      name: match,
      hubName: match$1,
      macAddress: match$2
    };
  }
}
function decodeResult(json) {
  if (Array.isArray(json)) {
    return Stdlib_Array.filterMap(json, decodeResultItem);
  } else {
    return [];
  }
}
function decodeInvalidRequestFailure(error) {
  if (error.kind === "NotFoundShopPrintersHub") {
    return "NoPrinterFound";
  } else {
    return "UnexpectedFailure";
  }
}
function mapFutureResult(futureResult) {
  return Future.mapError(Future.mapOk(futureResult, undefined, decodeResult), undefined, error => {
    if (typeof error !== "object" || error.TAG !== "InvalidRequestFailures") {
      return "UnexpectedFailure";
    } else {
      return Stdlib_Option.getOr(Stdlib_Option.map(error._0[0], decodeInvalidRequestFailure), "UnexpectedFailure");
    }
  });
}
function make(shopId) {
  return mapFutureResult(Request.make(makeEndpoint(shopId), "GET", undefined, undefined, undefined));
}
let SettingsLabelPrinterListRequest = {
  makeEndpoint: makeEndpoint,
  decodeResultItem: decodeResultItem,
  decodeResult: decodeResult,
  decodeInvalidRequestFailure: decodeInvalidRequestFailure,
  mapFutureResult: mapFutureResult,
  make: make
};
function makeEndpoint$1(shopId) {
  return Env.gatewayUrl() + "/printers-hub/" + printersHubName + "/" + shopId + "/default-printer";
}
function decodeResult$1(json) {
  let dict = Json.decodeDict(json);
  return Json.flatDecodeDictFieldString(Json.flatDecodeDictFieldDict(dict, "config"), "id");
}
function decodeInvalidRequestFailure$1(error) {
  if (error.kind === "NotFoundShopDefaultPrinterConfig") {
    return "NoPrinterFound";
  } else {
    return "UnexpectedFailure";
  }
}
function mapFutureResult$1(futureResult) {
  return Future.mapError(Future.mapOk(futureResult, undefined, decodeResult$1), undefined, error => {
    if (typeof error !== "object" || error.TAG !== "InvalidRequestFailures") {
      return "UnexpectedFailure";
    } else {
      return Stdlib_Option.getOr(Stdlib_Option.map(error._0[0], decodeInvalidRequestFailure$1), "UnexpectedFailure");
    }
  });
}
function make$1(shopId) {
  return mapFutureResult$1(Request.make(makeEndpoint$1(shopId), "GET", undefined, undefined, undefined));
}
let SettingsLabelDefaultPrinterIdRequest = {
  makeEndpoint: makeEndpoint$1,
  decodeResult: decodeResult$1,
  decodeInvalidRequestFailure: decodeInvalidRequestFailure$1,
  mapFutureResult: mapFutureResult$1,
  make: make$1
};
function makeEndpoint$2(shopId) {
  return Env.gatewayUrl() + "/printers-hub/" + printersHubName + "/" + shopId + "/setup";
}
function encodeBodyJson(apiKey) {
  return Json.encodeDict(Object.fromEntries([["printersHubConfig", Json.encodeDict(Object.fromEntries([["apiKey", Json.encodeString(apiKey)]]))]]));
}
function decodeResultItem$1(json) {
  let dict = Json.decodeDict(json);
  let decodeConfig = dict => {
    let match = Json.flatDecodeDictFieldString(dict, "id");
    let match$1 = Json.flatDecodeDictFieldString(dict, "groupId");
    if (match !== undefined && match$1 !== undefined) {
      return [match, match$1];
    }
  };
  let match = Json.flatDecodeDictFieldString(dict, "name");
  let match$1 = Json.flatDecodeDictFieldString(dict, "hubName");
  let match$2 = Json.flatDecodeDictFieldString(dict, "macAddress");
  let match$3 = decodeConfig(Json.flatDecodeDictFieldDict(dict, "config"));
  if (match !== undefined && match$1 !== undefined && match$2 !== undefined && match$3 !== undefined) {
    return {
      id: match$3[0],
      groupId: match$3[1],
      name: match,
      hubName: match$1,
      macAddress: match$2
    };
  }
}
function decodeResult$2(json) {
  let resultItems = Json.decodeArray(json);
  if (resultItems !== undefined) {
    return Stdlib_Array.filterMap(resultItems, decodeResultItem$1);
  } else {
    return [];
  }
}
function decodeInvalidRequestFailure$2(error) {
  switch (error.kind) {
    case "InvalidPrinterHubConfig":
    case "PrintersHubPermissionsCheck":
      return "InvalidAPIKey";
    default:
      return "UnexpectedFailure";
  }
}
function mapFutureResult$2(futureResult) {
  return Future.mapError(Future.mapOk(futureResult, undefined, decodeResult$2), undefined, error => {
    if (typeof error !== "object" || error.TAG !== "InvalidRequestFailures") {
      return "UnexpectedFailure";
    } else {
      return Stdlib_Option.getOr(Stdlib_Option.map(error._0[0], decodeInvalidRequestFailure$2), "UnexpectedFailure");
    }
  });
}
function make$2(shopId, apiKey) {
  return mapFutureResult$2(Request.make(makeEndpoint$2(shopId), "POST", {
    TAG: "JsonBody",
    _0: encodeBodyJson(apiKey)
  }, undefined, undefined));
}
let SettingsLabelPrinterHubSetupRequest = {
  makeEndpoint: makeEndpoint$2,
  encodeBodyJson: encodeBodyJson,
  decodeResultItem: decodeResultItem$1,
  decodeResult: decodeResult$2,
  decodeInvalidRequestFailure: decodeInvalidRequestFailure$2,
  mapFutureResult: mapFutureResult$2,
  make: make$2
};
function makeEndpoint$3(shopId) {
  return Env.gatewayUrl() + "/printers-hub/" + printersHubName + "/" + shopId + "/default-printer";
}
function encodeBodyJson$1(id, groupId) {
  return Json.encodeDict(Object.fromEntries([["defaultPrinterDeviceConfig", Json.encodeDict(Object.fromEntries([["id", Json.encodeString(id)], ["groupId", Json.encodeString(groupId)]]))]]));
}
function mapFutureResult$3(futureResult) {
  return Future.map(futureResult, undefined, result => {
    if (result.TAG === "Ok" && result._0 === "OK") {
      return {
        TAG: "Ok",
        _0: undefined
      };
    } else {
      return {
        TAG: "Error",
        _0: undefined
      };
    }
  });
}
function make$3(shopId, id, groupId) {
  let jwt = Auth.getJwt();
  return mapFutureResult$3(jwt !== undefined ? Future.mapError(FuturePromise.fromPromise(fetch(makeEndpoint$3(shopId), {
    method: "POST",
    body: Primitive_option.some(Json.stringify(encodeBodyJson$1(id, groupId))),
    headers: Primitive_option.some(new Headers({
      "Content-Type": "application/json",
      Authorization: `Bearer ` + jwt
    }))
  }).then(prim => prim.text()).then(text => Promise.resolve(text))), undefined, param => "UnexpectedFailure") : Future.value({
    TAG: "Error",
    _0: "UnexpectedFailure"
  }));
}
let SettingsLabelPrinterDefaultSelectionRequest = {
  makeEndpoint: makeEndpoint$3,
  encodeBodyJson: encodeBodyJson$1,
  mapFutureResult: mapFutureResult$3,
  make: make$3
};
let starPrinterUrl = new URL("https://portal.starprinter.online/Dashboard");
let secretTextPlaceholder = "• • • • • • • • • • • • • • • • • • • • • • • • • • •";
function SettingsLabelPrinterPage$SettingsLabelPrinterApiKeyEdit(props) {
  let onSubmit = props.onSubmit;
  let __loading = props.loading;
  let __editionStage = props.editionStage;
  let editionStage = __editionStage !== undefined ? __editionStage : false;
  let loading = __loading !== undefined ? __loading : false;
  let match = React.useState(() => "");
  let setApiKey = match[1];
  let apiKey = match[0];
  let match$1 = React.useState(() => false);
  let setEditionModalOpened = match$1[1];
  let editionModalOpened = match$1[0];
  if (!editionStage) {
    return JsxRuntime.jsxs(Stack.make, {
      children: [JsxRuntime.jsx(InputTextField.make, {
        label: I18n.t("StarPrinter Online API key"),
        placeholder: I18n.t("Enter API key"),
        value: apiKey,
        onChange: value => setApiKey(param => value)
      }), JsxRuntime.jsxs(Inline.make, {
        children: [JsxRuntime.jsx(TextLink.make, {
          text: "StarPrinter Online Dashboard",
          to: {
            TAG: "Url",
            _0: starPrinterUrl
          },
          openNewTab: true,
          highlighted: true,
          icon: "external_link"
        }), JsxRuntime.jsx(Button.make, {
          label: I18n.t("Save"),
          variant: "solid",
          tone: "success",
          disabled: apiKey === "",
          pending: loading,
          onPress: () => {
            onSubmit(apiKey);
            setApiKey(param => "");
          }
        })],
        align: "spaceBetween",
        alignY: "top"
      })],
      space: "large"
    });
  }
  let newrecord = {
    ...{
      style: {
        marginTop: "-8px"
      }
    }
  };
  return JsxRuntime.jsxs(Stack.make, {
    children: [JsxRuntime.jsx(Label.make, {
      text: I18n.t("StarPrinter Online API key")
    }), JsxRuntime.jsx("div", (newrecord.children = JsxRuntime.jsxs(Inline.make, {
      children: [JsxRuntime.jsx(TextStyle.make, {
        children: secretTextPlaceholder,
        weight: "semibold",
        size: "xlarge"
      }), JsxRuntime.jsx(IconButton.make, {
        name: "edit_light",
        size: 18,
        marginSize: "small",
        color: "#07061e",
        hoveredColor: "#8a0262",
        onPress: param => setEditionModalOpened(param => true)
      }), JsxRuntime.jsx(Modal.make, {
        children: JsxRuntime.jsx(Box.make, {
          children: JsxRuntime.jsx(InputTextField.make, {
            label: I18n.t("StarPrinter Online API key"),
            placeholder: I18n.t("Enter API key"),
            autoFocus: editionModalOpened,
            value: apiKey,
            onChange: value => setApiKey(param => value)
          }),
          spaceX: "xlarge",
          spaceTop: "xlarge",
          spaceBottom: "xmedium"
        }),
        opened: editionModalOpened,
        title: I18n.t("Edit StarPrinter Online API key"),
        abortButtonText: I18n.t("Cancel"),
        allowCommit: apiKey !== "",
        commitButtonText: I18n.t("Save"),
        commitButtonCallback: () => onSubmit(apiKey),
        onRequestClose: () => {
          setEditionModalOpened(param => false);
          setApiKey(param => "");
        }
      })],
      alignY: "center"
    }), newrecord))],
    space: "none"
  });
}
let SettingsLabelPrinterApiKeyEdit = {
  starPrinterUrl: starPrinterUrl,
  secretTextPlaceholder: secretTextPlaceholder,
  make: SettingsLabelPrinterPage$SettingsLabelPrinterApiKeyEdit
};
let starPrinterUrl$1 = new URL("https://portal.starprinter.online/Dashboard");
function formatPrinterLabel(name, macAddress) {
  if (name === "") {
    return I18n.t("Anonymous") + ` (` + macAddress + `)`;
  } else {
    return name + ` (` + macAddress + `)`;
  }
}
function SettingsLabelPrinterPage$SettingsLabelPrinterDefaultSelection(props) {
  let onSubmit = props.onSubmit;
  let defaultPrinterId = props.defaultPrinterId;
  let printers = props.printers;
  let __loading = props.loading;
  let loading = __loading !== undefined ? __loading : false;
  let defaultPrinter = printers.find(printer => printer.id === defaultPrinterId);
  let match = React.useState(() => defaultPrinter);
  let setPickedPrinter = match[1];
  let pickedPrinter = match[0];
  if (printers.length !== 1) {
    let items = printers.map(printer => ({
      TAG: "Option",
      key: printer.id,
      label: formatPrinterLabel(printer.name, printer.macAddress),
      value: printer
    }));
    return JsxRuntime.jsxs(Stack.make, {
      children: [JsxRuntime.jsx(InputSelectField.make, {
        label: I18n.t("Label printer"),
        placeholder: I18n.t("Select a printer"),
        onChange: printer => setPickedPrinter(param => printer),
        value: pickedPrinter,
        sections: [{
          items: items
        }]
      }), JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsxs(Inline.make, {
          children: [JsxRuntime.jsx(TextLink.make, {
            text: "StarPrinter Online Dashboard",
            to: {
              TAG: "Url",
              _0: starPrinterUrl$1
            },
            openNewTab: true,
            highlighted: true,
            icon: "external_link"
          }), JsxRuntime.jsx(Button.make, {
            label: I18n.t("Save"),
            variant: "solid",
            tone: "success",
            disabled: Stdlib_Option.isNone(pickedPrinter),
            pending: loading,
            onPress: () => {
              if (pickedPrinter !== undefined) {
                return onSubmit(pickedPrinter, printers);
              }
            }
          })],
          align: "spaceBetween",
          alignY: "top"
        }),
        spaceTop: "xlarge"
      })]
    });
  }
  let printer = printers[0];
  return JsxRuntime.jsxs(Inline.make, {
    children: [JsxRuntime.jsx(Title.make, {
      children: formatPrinterLabel(printer.name, printer.macAddress),
      level: 4,
      weight: "bold"
    }), JsxRuntime.jsx(TextLink.make, {
      text: "StarPrinter Online Dashboard",
      to: {
        TAG: "Url",
        _0: starPrinterUrl$1
      },
      openNewTab: true,
      highlighted: true,
      icon: "external_link"
    })],
    space: "medium"
  });
}
let SettingsLabelPrinterDefaultSelection = {
  starPrinterUrl: starPrinterUrl$1,
  formatPrinterLabel: formatPrinterLabel,
  make: SettingsLabelPrinterPage$SettingsLabelPrinterDefaultSelection
};
function SettingsLabelPrinterPage$SettingsLabelPrinterDocumentationCard(props) {
  return JsxRuntime.jsx(Card.make, {
    children: JsxRuntime.jsxs(Stack.make, {
      children: [JsxRuntime.jsx(TextStyle.make, {
        children: I18n.t("This is a unique code that you provide to us so that we can access your Star printer's online functions securely.")
      }), JsxRuntime.jsx(Stack.make, {
        children: JsxRuntime.jsx(TextAction.make, {
          text: I18n.t("Consult the tutorial dedicated to Star printer configuration and StarPrinter Online"),
          highlighted: true,
          onPress: () => HelpCenter.showArticle(HelpCenter.setupLabelPrinterAndStarPrinterOnline)
        }),
        space: "small"
      })],
      space: "medium"
    }),
    title: I18n.t("What is an API key?"),
    grow: true
  });
}
let SettingsLabelPrinterDocumentationCard = {
  make: SettingsLabelPrinterPage$SettingsLabelPrinterDocumentationCard
};
function SettingsLabelPrinterPage(props) {
  let match = React.useState(() => "NotAsked");
  let setPrintersResult = match[1];
  let printersResult = match[0];
  let match$1 = React.useState(() => {});
  let setDefaultPrinterId = match$1[1];
  let match$2 = React.useState(() => {});
  let setNotification = match$2[1];
  let notification = match$2[0];
  let shops = Auth.useShops();
  let activeShop = Stdlib_Option.getOr(Auth.useActiveShop(), shops[0]);
  let match$3 = Auth.useScope();
  let organisationAccount;
  organisationAccount = match$3.TAG === "Organisation";
  let requestPrintersList = () => Future.tap(make(activeShop.id), result => {
    if (result.TAG === "Ok") {
      let printers = result._0;
      return setPrintersResult(param => ({
        TAG: "Done",
        _0: {
          TAG: "Ok",
          _0: printers
        }
      }));
    }
    let error = result._0;
    switch (error) {
      case "InvalidAPIKey":
        return setNotification(param => ({
          TAG: "Error",
          _0: errorMessageFromError(error)
        }));
      case "NoPrinterFound":
        return setPrintersResult(param => ({
          TAG: "Done",
          _0: {
            TAG: "Ok",
            _0: undefined
          }
        }));
      case "UnexpectedFailure":
        setPrintersResult(param => ({
          TAG: "Done",
          _0: {
            TAG: "Ok",
            _0: undefined
          }
        }));
        return setNotification(param => ({
          TAG: "Error",
          _0: errorMessageFromError(error)
        }));
    }
  });
  React.useEffect(() => {
    if (typeof printersResult === "object") {
      return;
    }
    if (printersResult !== "NotAsked") {
      return;
    }
    let executedPrintersListFuture = requestPrintersList();
    let defaultPrinterFuture = make$1(activeShop.id);
    Future.tapOk(defaultPrinterFuture, id => setDefaultPrinterId(param => id));
    return () => {
      Future.cancel(executedPrintersListFuture);
      Future.cancel(defaultPrinterFuture);
    };
  }, [printersResult]);
  ReactUpdateEffect.use1(() => {
    setNotification(param => {});
    setPrintersResult(param => "Loading");
    let executedFuture = requestPrintersList();
    return () => Future.cancel(executedFuture);
  }, [activeShop]);
  let handleApiKeyChange = apiKey => {
    let printers = AsyncData.getWithDefault(printersResult, {
      TAG: "Ok",
      _0: undefined
    });
    setPrintersResult(param => ({
      TAG: "Reloading",
      _0: printers
    }));
    Future.get(Future.flatMapOk(make$2(activeShop.id, apiKey), undefined, printers => {
      if (printers.length !== 1) {
        return Future.value({
          TAG: "Ok",
          _0: printers
        });
      }
      let printer = printers[0];
      return Future.mapError(Future.mapOk(make$3(activeShop.id, printer.id, printer.groupId), undefined, () => printers), undefined, () => "UnexpectedFailure");
    }), result => {
      if (result.TAG === "Ok") {
        let latestPrinters = result._0;
        setPrintersResult(param => ({
          TAG: "Done",
          _0: {
            TAG: "Ok",
            _0: latestPrinters
          }
        }));
        return setNotification(param => ({
          TAG: "Ok",
          _0: I18n.t("The printer has been successfully registered.")
        }));
      }
      let error = result._0;
      setPrintersResult(param => ({
        TAG: "Done",
        _0: printers
      }));
      setNotification(param => ({
        TAG: "Error",
        _0: errorMessageFromError(error)
      }));
    });
  };
  let handleDefaultPrinterSelection = (printer, printers) => {
    setPrintersResult(param => ({
      TAG: "Reloading",
      _0: {
        TAG: "Ok",
        _0: printers
      }
    }));
    Future.get(Future.flatMap(make$3(activeShop.id, printer.id, printer.groupId), undefined, result => {
      if (result.TAG === "Ok") {
        return make$1(activeShop.id);
      } else {
        return Future.value({
          TAG: "Error",
          _0: "UnexpectedFailure"
        });
      }
    }), result => {
      if (result.TAG === "Ok") {
        let defaultPrinterId = result._0;
        setDefaultPrinterId(param => defaultPrinterId);
        setNotification(param => ({
          TAG: "Ok",
          _0: I18n.t("The default printer has been successfully registered.")
        }));
      } else {
        let error = result._0;
        setNotification(param => ({
          TAG: "Error",
          _0: errorMessageFromError(error)
        }));
      }
      setPrintersResult(param => ({
        TAG: "Done",
        _0: {
          TAG: "Ok",
          _0: printers
        }
      }));
    });
  };
  let renderHeaderActions = () => {
    if (organisationAccount) {
      return JsxRuntime.jsx(Inline.make, {
        children: JsxRuntime.jsx(Auth.SelectSingleShopFilter.make, {
          value: activeShop
        })
      });
    } else {
      return null;
    }
  };
  let notificationBanner;
  if (notification !== undefined) {
    let tmp;
    tmp = notification.TAG === "Ok" ? {
      TAG: "Success",
      _0: notification._0
    } : {
      TAG: "Danger",
      _0: notification._0
    };
    notificationBanner = JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(Banner.make, {
        textStatus: tmp,
        onRequestClose: () => setNotification(param => {})
      }),
      spaceTop: "normal"
    });
  } else {
    notificationBanner = null;
  }
  let tmp$1;
  let exit = 0;
  let printers;
  if (typeof printersResult !== "object") {
    exit = 3;
  } else if (printersResult.TAG === "Reloading") {
    let match$4 = printersResult._0;
    if (match$4.TAG === "Ok") {
      let printers$1 = match$4._0;
      if (printers$1 !== undefined) {
        printers = printers$1;
        exit = 2;
      } else {
        exit = 1;
      }
    } else {
      exit = 3;
    }
  } else {
    let match$5 = printersResult._0;
    if (match$5.TAG === "Ok") {
      let printers$2 = match$5._0;
      if (printers$2 !== undefined) {
        printers = printers$2;
        exit = 2;
      } else {
        exit = 1;
      }
    } else {
      tmp$1 = JsxRuntime.jsx(Placeholder.make, {
        status: "Error"
      });
    }
  }
  switch (exit) {
    case 1:
      let loading = AsyncData.isBusy(printersResult);
      tmp$1 = JsxRuntime.jsx(SettingsLabelPrinterPage$SettingsLabelPrinterApiKeyEdit, {
        loading: loading,
        onSubmit: handleApiKeyChange
      });
      break;
    case 2:
      let loading$1 = AsyncData.isBusy(printersResult);
      tmp$1 = JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsx(SettingsLabelPrinterPage$SettingsLabelPrinterApiKeyEdit, {
          editionStage: true,
          loading: loading$1,
          onSubmit: handleApiKeyChange
        }), JsxRuntime.jsx(SettingsLabelPrinterPage$SettingsLabelPrinterDefaultSelection, {
          loading: loading$1,
          printers: printers,
          defaultPrinterId: match$1[0],
          onSubmit: handleDefaultPrinterSelection
        })],
        space: "xnormal"
      });
      break;
    case 3:
      tmp$1 = JsxRuntime.jsx(Placeholder.make, {
        status: "Loading"
      });
      break;
  }
  return JsxRuntime.jsxs(Page.make, {
    children: [notificationBanner, JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsx(FieldsetLayoutPanel.make, {
          title: I18n.t("Configuration"),
          description: I18n.t("To connect your printer, enter the StarPrinter Online API key."),
          children: tmp$1
        }), JsxRuntime.jsxs(Group.make, {
          children: [JsxRuntime.jsx("div", {
            "aria-label": "blank"
          }), JsxRuntime.jsx(SettingsLabelPrinterPage$SettingsLabelPrinterDocumentationCard, {})],
          grid: ["25%", "75%"],
          wrap: false,
          spaceX: "xlarge"
        })],
        space: "xlarge"
      }),
      spaceTop: "large"
    })],
    variation: "compact",
    title: I18n.t("Label printer"),
    renderHeaderActions: renderHeaderActions
  });
}
let make$4 = React.memo(SettingsLabelPrinterPage);
export { printersHubName, errorMessageFromError, SettingsLabelPrinterListRequest, SettingsLabelDefaultPrinterIdRequest, SettingsLabelPrinterHubSetupRequest, SettingsLabelPrinterDefaultSelectionRequest, SettingsLabelPrinterApiKeyEdit, SettingsLabelPrinterDefaultSelection, SettingsLabelPrinterDocumentationCard, make$4 as make };
/* starPrinterUrl Not a pure module */